import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import '../pages/homepage.css';
import { useCommonVars } from './useCommonVars';

const formatDate = isoString => {
  const d = new Date(isoString);
  return d.toLocaleString('ru-RU',{day:'2-digit',month:'2-digit',year:'2-digit',hour:'2-digit',minute:'2-digit'});
};

function HomePage({ user, userDetails, transactions, btc, usdt, ton, eth }) {
  const { channelUrl, chatUrl, supportUrl } = useCommonVars(user);
  const [isPressed, setIsPressed] = useState(false);
  const [avatarOpen, setAvatarOpen] = useState(false);
  const navigate = useNavigate();

  const handleTopUpClick = () => {
    navigate("/card", { state: { openDepositModal: true } });
  };

  return (
    <>
      <div className="main-container">
        <div className="content-wrapper">
          <div className="header-container">
            <div className="box-assets">
              <div className="label-assets">Всего активов (RUB)</div>
              <div className="balance-amount">
                {userDetails?.deposit !== undefined
                  ? userDetails.deposit.toLocaleString("ru-RU",{minimumFractionDigits:2,maximumFractionDigits:2}) + "₽"
                  : "0,00₽"}
              </div>
            </div>
            <button
              className={`btn-topup ${isPressed ? 'pressed' : ''}`}
              onMouseDown={() => setIsPressed(true)}
              onMouseUp={() => setIsPressed(false)}
              onTouchStart={() => setIsPressed(true)}
              onTouchEnd={() => setIsPressed(false)}
              onClick={handleTopUpClick}
            >
              Пополнить
            </button>
          </div>

          <div className="live-title"><span className="dot" /> Live Транзакции</div>
          <div className="transactions">
            {transactions.length === 0 ? (
              <div className="empty-history">История операций пуста</div>
            ) : (
              transactions.map((tx) => (
                <div className="transaction-card" key={tx.id}>
                  <div className="row">
                    <div className="transaction-id">ID:{tx.telegram_id}</div>
                    <div className="transaction-date">{formatDate(tx.timestamp)}</div>
                  </div>
                  <div className="row">
                    <div className="transaction-type">{tx.type}</div>
                    <div className="transaction-amount">{tx.amount}</div>
                  </div>
                  <div className="transaction-line" />
                </div>
              ))
            )}
          </div>

          <div className="info-section">
            <div className="info-title">Информация</div>
            <div className="info-support">
              <div className="support-links">
                <a href={supportUrl} target="_blank" rel="noopener noreferrer" className="support-link" title="Поддержка">
                  <span className="icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M4 15V11C4 6.582 7.582 3 12 3C16.418 3 20 6.582 20 11V15" stroke="currentColor" strokeWidth="2"/>
                      <rect x="2" y="15" width="5" height="6" rx="2" stroke="currentColor" strokeWidth="2"/>
                      <rect x="17" y="15" width="5" height="6" rx="2" stroke="currentColor" strokeWidth="2"/>
                      <path d="M12 21V19" stroke="currentColor" strokeWidth="2"/>
                    </svg>
                  </span>
                  Поддержка
                </a>
                <span className="dot-sep">·</span>
                <a href={channelUrl} target="_blank" rel="noopener noreferrer" className="support-link" title="Канал">
                  <span className="icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M21 3L3 10.53L8.38 12.06L18.25 6.03C18.66 5.78 19.08 6.22 18.82 6.62L12.38 16.5V16.5L12.37 16.5L12.38 16.5V16.5L14.12 20.16C14.34 20.62 14.97 20.65 15.24 20.21L21 3Z" fill="currentColor"/>
                    </svg>
                  </span>
                  Канал
                </a>
                <span className="dot-sep">·</span>
                <a href={chatUrl} target="_blank" rel="noopener noreferrer" className="support-link" title="Чат">
                  <span className="icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M21 11.5C21 16.1944 16.9706 20 12 20C10.5709 20 9.22432 19.7453 8.02781 19.2929L3 20.5L4.20711 15.6725C3.44217 14.5208 3 13.0716 3 11.5C3 6.80558 7.02944 3 12 3C16.9706 3 21 6.80558 21 11.5Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
                    </svg>
                  </span>
                  Чат
                </a>
              </div>
            </div>
            <div className="info-subtitle">Партнерская программа</div>
            <div className="info-icons-box">
              <img src={btc} alt="btc" className="coin-icon" />
              <img src={usdt} alt="usdt" className="coin-icon" />
              <img src={ton} alt="ton" className="coin-icon" />
              <img src={eth} alt="eth" className="coin-icon" />
            </div>
            <div className="copyright">© 2025 | Все права защищены.</div>
          </div>
        </div>
      </div>
    </>
  );
}

export default HomePage;


